import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import BillingsTable from './BillingsTable';
import { useLazyGetBillingDetailsQuery } from '../../../../../store/services/student/ProfileService';
import CaretIcon from '../../../../../svg/CaretIcon';

export const StudentBillings = () => {
    const [billingData, setBillingData] = useState([]);
    const [totalCount, setTotalCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const [pageSize] = useState(10);

    const [triggerGetBillingDetails, { data, isLoading, error }] = useLazyGetBillingDetailsQuery();

    const fetchData = () => {
        triggerGetBillingDetails({ pageNumber: currentPage, pageSize, search: searchTerm });
    };

    useEffect(() => {
        fetchData();
    }, [currentPage, searchTerm]);

    useEffect(() => {
        if (data?.data) {
            setBillingData(data.data.items || []);
            setTotalCount(data.data.totalCount || 0);
        }
    }, [data]);

    if (isLoading) {
        return (
            <div className="content-body">
                <div className="container-fluid">
                    <div className="d-flex justify-content-center align-items-center" style={{ height: "300px" }}>
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="content-body">
                <div className="container-fluid">
                    <div className="alert alert-danger">
                        Error loading billing details: {error?.data?.errors?.[0] || 'Please try again later.'}
                    </div>
                </div>
            </div>
        );
    }

    const lastIndex = currentPage * pageSize;
    const firstIndex = lastIndex - pageSize;
    const totalPages = Math.ceil(totalCount / pageSize);
    const pageNumbers = Array.from({ length: totalPages }, (_, i) => i + 1);
    const visiblePages = pageNumbers.slice(
        Math.max(currentPage - 2, 0),
        Math.min(currentPage + 1, totalPages)
    );

    return (
        // <div className="content-body">
            // <div className="container-fluid">
            <div className="bg-white">
                {/* Search Section */}
                <div className="page-title flex-wrap mb-3">
                    <div className="input-group search-area mb-md-0 ml-3">
                        <input
                            type="text"
                            className="form-control ps-4"
                            placeholder="Search billing records..."
                            value={searchTerm}
                            onChange={(e) => {
                                setCurrentPage(1);
                                setSearchTerm(e.target.value);
                            }}
                        />
                    </div>
                </div>

                {/* Billing Table */}
                <BillingsTable billings={billingData} />

                {/* Pagination */}
                <div id="example-student_wrapper" className="dataTables_wrapper no-footer">
                    <div className="bg-white rounded shadow d-sm-flex text-center justify-content-between align-items-center mt-3">
                        <div className="dataTables_info">
                            Showing {firstIndex + 1} to {Math.min(lastIndex, totalCount)} of {totalCount} entries
                        </div>
                        <div className="dataTables_paginate paging_simple_numbers mb-0 me-2">
                            <Link
                                className={`paginate_button previous ${currentPage === 1 ? 'disabled' : ''}`}
                                onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                            >
                                <CaretIcon direction="right" width="25" height="25" />
                            </Link>
                            <span>
                                {visiblePages.map((page) => (
                                    <Link
                                        key={page}
                                        className={`paginate_button ${currentPage === page ? 'current' : ''}`}
                                        onClick={() => setCurrentPage(page)}
                                    >
                                        {page}
                                    </Link>
                                ))}
                            </span>
                            <Link
                                className={`paginate_button next ${currentPage === totalPages ? 'disabled' : ''}`}
                                onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
                            >
                                <CaretIcon direction="left" width="25" height="25" />
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
         //</div>
    );
};